import styles from "./styles.module.scss";
import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateDataset } from "../../../../redux/dataset/datasetSlice";

const TranscriptTitle = ({ title, editLocked }) => {
  const [titleEditable, setTitleEditable] = useState(false);
  const titleField = useRef(null);
  const measureRef = useRef(null);
  const dispatch = useDispatch();
  const [inputWidth, setInputWidth] = useState("auto");

  useEffect(() => {
    if (measureRef.current) {
      setInputWidth(`${measureRef.current.offsetWidth}px`);
    }
  }, [title]);

  const toggleTitleEditable = () => {
    if (titleEditable) {
      const updatedTitle = titleField.current.value;
      dispatch(updateDataset({ title: updatedTitle }));
    }
    setTitleEditable(!titleEditable);
  };

  const getFirstNChars = (str, number) => {
    if (!str) return '';
    return str.length > number ? str.substring(0, number) + ' ...' : str;
  };

  return (
    <div className={styles.titleWrapper}>
      <h1>
        {titleEditable ? (
          <input
            className={styles.speakerNameInput}
            ref={titleField}
            defaultValue={title}
            style={{ width: inputWidth }}
          />
        ) : (
          <span className={styles.speakerName}>{getFirstNChars(title, 50)}</span>
        )}
        {/* This is the invisible span for measuring the content width */}
        <span
          ref={measureRef}
          style={{
            position: "absolute",
            top: "-9999px",
            left: "-9999px",
            whiteSpace: "pre",
          }}
        >
          {title}
        </span>
      </h1>
      {!editLocked && (
        <img
          className={styles.edit}
          src={titleEditable ? "/icons/check-mark.svg" : "/icons/blue-edit.svg"}
          alt="edit"
          onClick={toggleTitleEditable}
        />
      )}
    </div>
  );
};

export default TranscriptTitle;
